// extracted by mini-css-extract-plugin
module.exports = {"make":"Lens_make__1m46s"};